import { createSelector } from "reselect";
import get from "lodash/get";
import { forms } from "utils/constants";

/**
 * Extracting Profile from values
 * @param {object} state
 */
const profileFormDomain = state =>
  get(state, `form.${forms.PROFILE_FORM}.values`, {});

const serviceReqestFormDomain = state =>
  get(state, `form.${forms.SERVICE_REQUEST}.values`, {});

/**
 * ************ Profile Form Selectors ************
 */
export const profileFormSelector = createSelector(
  profileFormDomain,
  profileForm => profileForm
);

export const selectedActiveLineSelector = createSelector(
  serviceReqestFormDomain,
  profileForm => get(profileForm, "selected_active_line", {})
);

/**
 * ************ Make Selectors ************
 */
export const makeSelectProfileForm = () => profileFormSelector;
export const makeSelectSelectedActiveLine = () => selectedActiveLineSelector;
